import base from '../../../site.config';

const config = {};

config.LOADING = {
  COLOR: '#ffed00',
};

export default { ...config, ...base };
